/**
 * Семантика цвета на стоковой палитре Mantine.
 *
 * Своих тюплов нет намеренно: набор Mantine уже сбалансирован по контрасту
 * во всех десяти оттенках, а самодельная шкала это ручная работа, которую
 * пришлось бы перепроверять на каждом фоне.
 *
 * Сигнальные цвета отделены от акцента: статус узла не должен зависеть от
 * брендового цвета, иначе смена бренда меняет смысл интерфейса.
 */

/** Акцент интерфейса: кнопки, активный пункт, ссылки. */
export const ACCENT = 'blue';

/**
 * Цвет статуса.
 *
 * Норма — серый, а не зелёный. В парке, где исправны девяносто пять машин
 * из ста, зелёная плашка на каждой строке превращается в фон, и на нём
 * теряется единственная красная.
 */
export function severityColor(severity: string): string {
  switch (severity) {
    case 'critical':
      return 'red';
    case 'warn':
    case 'important':
    case 'major':
      return 'orange';
    default:
      return 'gray';
  }
}

export function verdictColor(verdict: string): string {
  switch (verdict) {
    case 'critical':
      return 'red';
    case 'defects':
    case 'warn':
      return 'orange';
    default:
      return 'gray';
  }
}
